<umkt-auth-layout>
  <div class="auth-back">
    @if (!isMobileLogin || mobileBackGoesHome) {
      <a routerLink="/">
        <mat-icon>chevron_left</mat-icon>
        {{ 'shared.buttons.back' | i18n }}
      </a>
    } @else {
      <a (click)="goBackToNormalLogin()" style="cursor: pointer;">
        <mat-icon>chevron_left</mat-icon>
        {{ 'shared.buttons.back' | i18n }}
      </a>
    }
  </div>
  <div class="auth-card-content">
    <div class="auth-card-form">
      <div class="auth-intern-form">
        <div class="auth-title font-highlight">
          <h1>{{ 'pages.login.title' | i18n }} <span class="auth-title-highlight">{{ 'pages.login.titleHighlight' | i18n }}</span></h1>
        </div>

        @if (showEmailForm) {
          <p class="auth-desc">
            {{ (isMobileLogin ? 'pages.login.mobileWelcome' : 'pages.login.welcome') | i18n }}
          </p>
        }
        <form [formGroup]="loginForm" class="auth-form" (ngSubmit)="login()">
          @if (showEmailForm) {
            <umkt-custom-input
              formControlName="email"
              type="email"
              [ariaLabel]="('pages.login.email' | i18n) + '*'"
              [placeholder]="(isMobileLogin ? 'pages.login.mobileEmailPlaceholder' : 'pages.login.emailPlaceholder') | i18n"
              [maxlength]="255">
            </umkt-custom-input>

            <umkt-custom-input
              [id]="'auth-senha'"
              [type]="'password'"
              [ariaLabel]="'pages.login.password' | i18n"
              [placeholder]="'pages.login.passwordPlaceholder' | i18n"
              [formControlName]="'password'">
            </umkt-custom-input>

            <div class="auth-options">
              <div class="align-options">
                <label for="remember">
                  <input type="checkbox" id="remember" name="remember" formControlName="remember" />
                  {{ 'pages.login.remember' | i18n }}
                </label>
                @if (!isMobileLogin) {
                  <a class="forgot-link" routerLink="/forgot-password">
                    {{ 'pages.login.forgotPassword' | i18n }}
                  </a>
                }
              </div>
            </div>

            <ustore-button [type]="'submit'" [format]="'filled'" [backgroundColor]="'var(--color-red-500-to-yellow)'" [textColor]="'var(--color-inverted)'"
              [size]="'medium'" [rounded]="'default'" [text]="getButtonText()" [full]="true"
              [disabled]="isLoginButtonDisabled">
            </ustore-button>
            <br>
            @if (shouldShowResendButton) {
              <ustore-button [type]="'button'" [format]="'outlined'" [backgroundColor]="'var(--color-red-500-to-yellow)'" [textColor]="'var(--color-red-500-to-yellow)'"
                [size]="'medium'" [rounded]="'default'" [text]="'pages.login.resendConfirmation' | i18n"  [full]="true"
                (click)="resendConfirmationEmailFromLogin()">
              </ustore-button>
            }
          }

          @if (claroOptions.length) {
            <div>
              @if (separatorBeforeClaro) {
                <div class="auth-separator">
                  <span class="separator-text">{{ 'pages.login.separator' | i18n }}</span>
                </div>
              }

              @for (option of claroOptions; track option.kind; let isLast = $last) {
                <button type="button" class="auth-claro-button" (click)="chooseClaro(option.kind)">
                  <div class="claro-logo-icon">
                    <svg width="30" height="30" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="#DA291C">
                      <g transform="translate(8, 0)">
                        <path
                          d="M8 19c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.345 3 3-1.345 3-3 3zm0-8C5.243 11 3 13.243 3 16s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z">
                        </path>
                        <g>
                          <path d="M19.182 6.232L14.233 11.182 12.818 9.767 17.768 4.817z"></path>
                          <path d="M15 17h6v-2h-6z"></path>
                          <path d="M7 9h2V3H7z"></path>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <div class="claro-button-content">
                    <span class="claro-button-text">{{ option.labelKey | i18n }}</span>
                    <span class="claro-button-desc">{{ option.descriptionKey | i18n }}</span>
                  </div>
                </button>

                @if (!isLast) {
                  <div class="auth-separator">
                    <span class="separator-text">{{ 'pages.login.separator' | i18n }}</span>
                  </div>
                }
              }
            </div>
          }
          @if (showProspectLogin) {
            <div class="auth-register">{{'pages.login.noAccount' | i18n}} <a routerLink="/register">{{'pages.login.register' | i18n}} </a></div>
          }
        </form>
      </div>
    </div>
  </div>
</umkt-auth-layout>
